<script>
import i18n from '@/i18n';
import { mapActions } from "pinia";
import { newsStore } from "@/store/newsStore";

export default {
  props: {
    news: {
      type: Object,
    },
  },
  methods: {
    ...mapActions(newsStore, ['updateConsolidatedNewsList']),
  },
  computed: {
    forum() {
      // eslint-disable-next-line radix
      return parseInt(this.news.textParams[2]) > 1
        ? i18n.t('news.template.party.updatedNameConsolidated.p4s')
        : i18n.t('news.template.party.updatedNameConsolidated.p4');
    },
  },
};
</script>

<template>
  <div>
    {{news.textParams[0]}} {{$t('news.template.party.updatedNameConsolidated.p1')}}
    {{news.textParams[1]}}{{$t('news.template.party.updatedNameConsolidated.p2')}}
    {{news.textParams[1]}} {{$t('news.template.party.updatedNameConsolidated.p3')}}
    <a class="consolidated-news"
       href="#"
       @click.prevent="updateConsolidatedNewsList(news.stringChildIds)"
    >{{news.textParams[2]}}</a>
    {{forum}}
  </div>
</template>
